import { BrowserRouter, Routes, Route } from 'react-router-dom';
import ProfileCard from './ProfileCard';
import Converter from './Converter';
import Calendar from './Calendar';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<ProfileCard />} />
        <Route path="/converter" element={<Converter />} />
        <Route path="/calendar" element={<Calendar />} />
        <Route path="*" element={
          <div style={{ minHeight: "var(--vh100)", padding: 24, textAlign: "center", display: "flex", alignItems: "center", justifyContent: "center", fontFamily: "'0xProto', 'JetBrains Mono', monospace", fontSize: 15 }}>
            404 — page not found
          </div>
        } />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
